import { XYCoord } from 'dnd-core';
import React from "react";
import {
	ConnectDragSource,
	ConnectDropTarget,
	DragSource,
	DragSourceConnector,
	DragSourceMonitor,
	DropTarget,
	DropTargetConnector,
	DropTargetMonitor
} from "react-dnd";
import { findDOMNode } from "react-dom";

import { ID } from "common/entities/IEntity";

interface IItemProps {
	id: ID;
	children: JSX.Element | string;
	index: number;
	isDragging?: boolean;
	connectDragSource?: ConnectDragSource;
	connectDropTarget?: ConnectDropTarget;
	moveItem: (dragIndex: number, hoverIndex: number) => void;
}

const itemSource = {
	beginDrag(props) {
		return {
			id: props.id,
			index: props.index
		};
	}
};

const itemTarget = {
	hover(props: IItemProps, monitor: DropTargetMonitor, component: ListItem | null) {
		if (!component) {
			return null;
		}
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;

		if (dragIndex === hoverIndex) {
			return;
		}

		const hoverBoundingRect = (findDOMNode(component) as Element).getBoundingClientRect();

		const hoverMiddleY: number = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
		const clientOffset = monitor.getClientOffset();
		const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return;
		}

		props.moveItem(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	}
};

@DropTarget("listitem", itemTarget, (connect: DropTargetConnector) => ({
	connectDropTarget: connect.dropTarget()
}))
@DragSource("listitem", itemSource, (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging()
}))
export default class ListItem extends React.Component<IItemProps> {

	public render() {
		const {
			children, 
			isDragging,
			connectDragSource,
			connectDropTarget
		} = this.props;

		const opacity = isDragging ? 0.4 : 1;

		return (
			connectDragSource &&
			connectDropTarget &&
			connectDropTarget(
				connectDragSource(
					<div style={{opacity}}>
						{children}
					</div>
				)
			)
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/listOrder/ListItem.tsx